import { render, staticRenderFns } from "./Accord.vue?vue&type=template&id=467bdae8&"
import script from "./Accord.vue?vue&type=script&lang=js&"
export * from "./Accord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467bdae8')) {
      api.createRecord('467bdae8', component.options)
    } else {
      api.reload('467bdae8', component.options)
    }
    module.hot.accept("./Accord.vue?vue&type=template&id=467bdae8&", function () {
      api.rerender('467bdae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Accord.vue"
export default component.exports